export enum DateTypeFrontend {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
}

export enum DateTypeBackend {
  Day = 'daily',
  Week = 'weekly',
  Month = 'monthly',
}

export enum DateTypeFrontendLow {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}
